<template>
  <div class="zj-emergency-operations-right-panel select-none">
    <div class="zj-emergency-operations-search-box select-none">
      <div class="zj-emergency-operations-xiafa-btn" @click="newtask">
        <img src="../../../../theme-default/src/images/emergencyoperations-icon-xiafa.png" />
        下发任务
      </div>
    </div>
    <div class="zj-emergency-operations-task-summary">
      <TaskSummary v-bind:info="executStat" />
    </div>
    <div class="zj-emergency-operations-task-process">
      <TaskProcess
        v-bind:ExecutId="ExecutId"
        v-bind:tableData="tableData"
        v-bind:planName="planName"
        v-bind:planId="planId"
        v-bind:optionsObj="optionsObj"
        :roomId="roomId" :pwd="pwd"
      />
    </div>
    <el-dialog
      class="emergencyoperations-dialog normal"
      custom-class="bg3"
      top="6vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isNewtaskVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <NewTask
        @handlerclose="isNewtaskVisiable=false"
        v-bind:tableData="tableData"
        v-bind:ExecutId="ExecutId"
      />
    </el-dialog>
  </div>
</template>

<script>
import Constant from "../config/constant";

import TaskSummary from "./Component-Tasksummary";
import TaskProcess from "./Component-TaskProcess";
import NewTask from "./Component-NewTask";

export default {
  name: "ZJEmergencyOperationsRightPanel",
  componentName: "ZJEmergencyOperationsRightPanel",
  components: {
    TaskSummary: TaskSummary,
    TaskProcess: TaskProcess,
    NewTask: NewTask
  },
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },  
    optionsObj: {
      type: Array,
      default: function() {
        return {};
      }
    },
    planName: String,
    planId: String,
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  data: function() {
    return {
      info: {
        exception: 0,
        todo: 0,
        finished: 0
      },
      isNewtaskVisiable: false
    };
  },
  methods: {
    newtask: function() {
      this.isNewtaskVisiable = true;
    },
  },
  computed: {
    executStat: function() {
      if (!this.tableData || this.tableData.length == 0)
        return {
          exception: 0,
          todo: 0,
          finished: 0
        };

      var exceptionCount = this.tableData.filter(function(item) {
        return (
          item.status == 3
        );
      }).length;

      var todoCount = this.tableData.filter(function(item) {
        return (
          item.status == 1
        );
      }).length;

      var doneCount = this.tableData.filter(function(item) {
        return (
        item.status == 2
        );
      }).length;

      return {
        exception: exceptionCount,
        todo: todoCount,
        finished: doneCount
      };
    }
  }
};
</script>